
cmStatusChartCtrl.$inject = ['$scope', '$filter', 'reviewDetailModal'];
function cmStatusChartCtrl($scope, $filter, reviewDetailModal) {
  $scope.steps = [];
  const dateFormat = 'MM/dd/yyyy @ h:mm:ssa';

  // Add all delivery steps
  ($scope.contact.deliverySteps || []).map(deliveryStep => {

    var tooltipMessage = `Message scheduled to send on ${$filter('date')(deliveryStep.date.$date, dateFormat)}`
    if (deliveryStep.processingCompleted) {
      switch(deliveryStep.status) {
        case "Cancelled":
          tooltipMessage = `Message cancelled on ${$filter('date')(deliveryStep.processingCompleted.$date, dateFormat)}`;
          break;
        case "Failed":
          tooltipMessage = `Message failed on ${$filter('date')(deliveryStep.processingCompleted.$date, dateFormat)}`;
          break;
        default:
          tooltipMessage = `Message sent on ${$filter('date')(deliveryStep.processingCompleted.$date, dateFormat)}`;
      }
      if (deliveryStep.statusDetails) {
        tooltipMessage = tooltipMessage + ". " + deliveryStep.statusDetails;
      }
    }
    $scope.steps.push({
      type: deliveryStep.eventType,
      status: deliveryStep.status,
      completed: typeof deliveryStep.processingCompleted !== "undefined",
      tooltip: tooltipMessage,
      onClick: _.noop
    });
  });

  // Add review submitted step
  let lastReviewIndex = _.findLastIndex($scope.contact.contactLog, event => event.type == 'reviewSubmitted');
  let lastRequeueIndex = _.findLastIndex($scope.contact.contactLog, event => event.type == 'reQueued');
  if (lastReviewIndex > lastRequeueIndex) {
    let reviewEvent = $scope.contact.contactLog[lastReviewIndex];
    $scope.steps.push({
      type: 'review',
      completed: true,
      tooltip: `Review submitted on ${$filter('date')(reviewEvent.date.$date, dateFormat)}`,
      onClick: () => reviewDetailModal.openById(reviewEvent.reviewId, reviewEvent.campaignId)
    });

    // Remove any more events, as we will not be sending them!
    $scope.steps = $scope.steps.filter(step => step.completed);
  } else {
    $scope.steps.push({
      type: 'review',
      completed: false,
      tooltip: `Awaiting review submission`,
      onClick: _.noop
    })
  }

  // Add unsubscribe step
  let unsubscribeEvent = $scope.contact.contactLog ? _.find($scope.contact.contactLog, event => event.type == 'unsubscribed') : null;

  if (unsubscribeEvent) {
    $scope.steps.push({
      type: 'cancelled',
      completed: true,
      tooltip: `Opted out on ${$filter('date')(unsubscribeEvent.date.$date, dateFormat)}`
    });

    // If we've unsubscribed, nothing more should happen, so remove all incomplete steps
    $scope.steps = $scope.steps.filter(step => step.completed)
  }

}

angular.module('clientDashboardApp.reviewBuilder').directive('cmStatusChart', function() {
  return {
    restrict: 'E',
    template: require('./statusChartDirective.html'),
    scope: {
      contact: '='
    },
    controller: cmStatusChartCtrl
  };
});
